import * as React from 'react';
import moment from 'moment';
import styled from 'styled-components';
import _ from 'lodash';
import { getRoomIconById } from '../../util/rooms';
import CloseIcon from './icons/CloseIcon';
import { Text } from '../Text';

const RoomAnalyticsHeaderRow = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const RoomName = styled(Text)`
  font-size: 24px;
  line-height: 32px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.font1};
`;

const StyledTimeBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-weight: 600;
  font-size: 12px;
  line-height: 24px;
  letter-spacing: 0.18px;
  color: ${({ theme }) =>
    theme.isDark ? theme.colors.white60 : theme.colors.font3};
`;

export const StyledConsumptionSpacer = styled.div`
  height: 1px;
  background: ${({ theme }) => theme.colors.white05};
  opacity: 0.5;
  width: 100%;
  margin: 32px 0px;
`;

const StyledTimeSpacer = styled.div`
  height: 8px;
  width: 1px;
  background: ${({ theme }) =>
    theme.isDark ? theme.colors.white60 : theme.colors.font3};
  margin: 0px 5px;
  opacity: 0.5;
`;

const StyledCloseIconWrapper = styled.div`
  cursor: pointer;
  position: absolute;
  right: -10px;
  top: -20px;
  ${({ theme }) => theme.mediaQueries.medium} {
    right: -60px;
  }
`;

export interface IAnalyticsHeaderRowProps {
  headerTitle: string;
  lastUpdatedTime?: moment.Moment;
  roomTypeId?: string;
  closeModalHandler?: () => void;
}

const AnalyticsHeaderRow: React.FunctionComponent<IAnalyticsHeaderRowProps> = props => {
  const {
    headerTitle,
    lastUpdatedTime,
    roomTypeId = '',
    closeModalHandler
  } = props;

  const updatedTime = lastUpdatedTime || moment(new Date());
  const getFormatedDate = (): { hour: string; date: string } => {
    return {
      hour: updatedTime.format('LT'),
      date: updatedTime.format('D MMM YYYY')
    };
  };

  return (
    <RoomAnalyticsHeaderRow>
      <div>
        <RoomName>{headerTitle}</RoomName>
        <StyledTimeBox>
          {getFormatedDate().hour}
          <StyledTimeSpacer />
          {getFormatedDate().date}
        </StyledTimeBox>
      </div>
      {!_.isEmpty(roomTypeId) && (
        <>
          {getRoomIconById(roomTypeId, 'room-btn__icon')}
          <StyledCloseIconWrapper onClick={() => closeModalHandler()}>
            <CloseIcon />
          </StyledCloseIconWrapper>
        </>
      )}
    </RoomAnalyticsHeaderRow>
  );
};

export default AnalyticsHeaderRow;
